<template>
  <div class="drawing-room"
    :style="{ cursor: 'url(' + pointerCursor + '), auto'}">
    <Navbar name="Misalignments" />    
    <DetailMasks
      name="DrawingRoom"
      :galleries="galleries"
      :showLabels="this.showLabels"
    />  
    <BackgroundImage name="DrawingRoom" :galleries="galleries" :showLabels="this.showLabels" /> 
    <DetailViewer :items="items" :imgSize="imgSize" :isVisible="this.showLabels"/>
    <Footer gallery="Room of Traces" :galleryText="galleryText" @show="setLabelsVisible" />  
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import DetailViewer from "@/components/DetailViewer.vue";
import Footer from "@/components/Footer.vue";
import BackgroundImage from "@/components/BackgroundImage.vue";
import json from "@/assets/json/galleries.json";
import DetailMasks from "@/components/DetailMasks.vue";

export default {
  name: "DrawingRoom",
  props: ["galleries"],
  components: {
    Navbar, 
    DetailViewer,
    Footer,
    BackgroundImage,
    DetailMasks
  },
  data: function() {
    return {
      name: "DrawingRoom",
      showLabels: false,
      pointerCursor: require('@/assets/cursors/magnify.svg'),
      clickCursor: require('@/assets/cursors/pointer.svg'),
    };
  },
  beforeRouteEnter(to, from, next) {
    let img = new Image();
    img.src = require("@/assets/galleries/" + json["galleries"]["Home"][0]["image"]);
    
    let img2 = new Image();
    img2.src = require("@/assets/galleries/" + json["galleries"]["VideoRoom"][0]["image"]);
    
    setTimeout(function() {
      next();
    }, 250);
  },
  methods: {
    setLabelsVisible(bVisible) {
      this.showLabels = bVisible;
    },
  },
  computed: {
    imgSize: function() {
        return this.galleries["galleries"][this.name][0]["imageSize"];
    },
    items: function() {
       return this.galleries["galleries"][this.name][0]["items"];
    },
    galleryText: function() {
      return this.galleries["galleries"][this.name][0]["galleryText"];
    }
  },
  created() {
  },
  destroyed() {
  }
};
</script>

<style scoped>
</style>
